import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import { RegisterUserStamp } from '../../../business-entities/register-user-stamp';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { UserClockInOutService } from '../../../business-services/user-clock-in-out.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as moment from 'moment';

@Component({
  selector: 'app-add-user-clock-in-out',
  templateUrl: './add-user-clock-in-out.component.html',
  styleUrls: ['./add-user-clock-in-out.component.scss']
})
export class AddUserClockInOutComponent implements OnInit {
  userClockInOutId = 0;
  selectedUser: string;
  isEdit = false;
  userClockInForm: FormGroup;
  userList: Array<SelectListItemViewModel>;
  userSelected: string;
  FromTimeObj: any;
  ToTimeObj: any;
  stampInDate: string;
  stampOutDate: string;
  userStampInOut: RegisterUserStamp = {
    id: 0,
    userId: null,
    createdBy: null,
    isAdvanceSearch: false,
    isDeleted: false,
    isManualOperation: true,
    PageSize: 0,
    SortColumn: '',
    sortDirection: '',
    startRecordNumber: 0,
    stampIn: new Date(),
    stampOut: null,
    comment: null,
    location: ''
  };

  constructor(
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private secureService: SecureStorage,
    private dataProvider: DataService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    public userClockInOutService: UserClockInOutService
  ) {}

  get cpf() {
    return this.userClockInForm.controls;
  }

  get areStampTimingsInvalid() {
    let areDatesInvalid = false;
    if (
      (this.userClockInForm.controls.stampInTime?.value?.hour >
        this.userClockInForm.controls.stampOutTime?.value?.hour ||
        (this.userClockInForm.controls.stampInTime?.value?.hour ===
          this.userClockInForm.controls.stampOutTime?.value?.hour &&
          this.userClockInForm.controls.stampInTime?.value?.minute >
            this.userClockInForm.controls.stampOutTime?.value?.minute))
    ) {
      areDatesInvalid = true;
    }
    return areDatesInvalid;
  }

  get areStampDatesInvalid() {
    let areDatesInvalid = false;
    if (
      this.userClockInForm.controls.stampInDate.value !== null &&
      this.userClockInForm.controls.stampOutDate.value !== null &&
      this.userClockInForm.controls.stampInDate.value !== undefined &&
      this.userClockInForm.controls.stampOutDate.value !== undefined &&
      this.userClockInForm.controls.stampInDate.value !==
        this.userClockInForm.controls.stampOutDate.value
    ) {
      areDatesInvalid = true;
    }

    return areDatesInvalid;
  }

  get startDateForStampOut() {
    const date =
      this.userClockInForm.controls.stampInDate.value !== null &&
      this.userClockInForm.controls.stampInDate.value !== undefined
        ? new Date(this.userClockInForm.controls.stampInDate.value)
        : new Date(2011, 1, 1);

    return date.toISOString().slice(0, 10).replace(/-/g, '/');
  }

  get getTodaysDate(): string {
    const today: Date = new Date();
    const formatted: string = today
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, '/');
    return formatted;
  }

  async ngOnInit(): Promise<void> {
    this.bindForm();
    await this.getUsers();
    if (this.userClockInOutService.isEdit) {
      this.userClockInOutId = this.userClockInOutService.userClockInOutId;
      this.isEdit = this.userClockInOutService.isEdit;
      this.fetchEditFormData();
    }
  }

  public OnClose() {
    this.activeModal.close({ success: false });
  }

  public onSubmit() {
    if (this.userClockInForm.valid) {
      const now = new Date();
      let stampInTime = null;
      let stampOutTime = null;
      const stampInDate = this.userClockInForm.controls.stampInDate.value;
      stampInTime = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        this.userClockInForm.controls.stampInTime.value.hour,
        this.userClockInForm.controls.stampInTime.value.minute,
        this.userClockInForm.controls.stampInTime.value.second
      );
      if(this.userClockInForm.controls.stampOutTime.value != null){
        stampOutTime = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          this.userClockInForm.controls.stampOutTime.value.hour,
          this.userClockInForm.controls.stampOutTime.value.minute,
          this.userClockInForm.controls.stampOutTime.value.second
        );
      }
      const currentTime = new Date();
      const specificDate = moment(stampInDate, 'DD.MM.YYYY').toDate();;

      const isTodaySpecificDate = (
        now.getFullYear() === specificDate.getFullYear() &&
        now.getMonth() === specificDate.getMonth() &&
        now.getDate() === specificDate.getDate()
      );
      if (isTodaySpecificDate && ((stampInTime && stampInTime > currentTime) || (stampOutTime && stampOutTime > currentTime))) {
        this.toastr.error(this.translate.instant("lblCannotInsertFutureTime"));
      }
      else {
        this.userStampInOut.userId = this.userClockInForm.controls.userId.value;

        const userData = this.secureService.getKeyData(
          fromEnums.SecureStorageKey.GetUserDetails
        );
        this.userStampInOut.createdBy = userData.userId;
        this.userStampInOut.comment = this.userClockInForm.controls.comment.value;
        if (
          this.userClockInForm.controls.stampInDate.value !== null &&
          this.userClockInForm.controls.stampInDate.value !== undefined
        ) {
          let stampInDate = this.getDate(
            this.userClockInForm.controls.stampInDate.value
          );
          this.userStampInOut.stampIn = new Date(
            stampInDate.getFullYear(),
            stampInDate.getMonth(),
            stampInDate.getDate(),
            this.userClockInForm.controls.stampInTime.value.hour,
            this.userClockInForm.controls.stampInTime.value.minute
          );
        }
        if (
          this.userClockInForm.controls.stampOutDate.value !== null &&
          this.userClockInForm.controls.stampOutDate.value !== undefined
        ) {
          let stampOutDate = this.getDate(
            this.userClockInForm.controls.stampOutDate.value
          );
          this.userStampInOut.stampOut = new Date(
            stampOutDate.getFullYear(),
            stampOutDate.getMonth(),
            stampOutDate.getDate(),
            this.userClockInForm.controls.stampOutTime.value.hour,
            this.userClockInForm.controls.stampOutTime.value.minute
          );
        }
        if (this.isEdit) {
          this.userStampInOut.id = this.userClockInForm.controls.id.value;
        }
        this.setUserStampInOut(this.userStampInOut);
      }
    }
  }

  private fetchEditFormData() {
    this.spinner.show();
    this.userClockInOutService
      .getUserClockInOut({ id: this.userClockInOutId })
      .then((response) => {
        if (response) {
          let resData = response[0];
          this.selectedUser = this.userList.filter((x) =>
            x.value === resData.userId ? x.text : ''
          )[0].text;
          this.stampInDate = this.datePipe.transform(
            Utility.ConvertUTCDateToLocalDate(resData.stampIn),
            'dd.MM.yyyy'
          );
          this.stampOutDate = resData.stampOut ? this.datePipe.transform(
            Utility.ConvertUTCDateToLocalDate(resData.stampOut),
            'dd.MM.yyyy'
          ) : resData.stampOut;
          this.userClockInForm.patchValue({
            id: resData.id,
            userId: resData.userId,
            comment: resData.comment,
            stampInTime: {
              hour: Utility.ConvertUTCDateToLocalDate(resData.stampIn).getHours(),
              minute: Utility.ConvertUTCDateToLocalDate(resData.stampIn).getMinutes(),
              second: 0,
            },
          });
          if (resData.stampOut) {
            this.userClockInForm.controls.stampOutTime.patchValue({
              hour: Utility.ConvertUTCDateToLocalDate(resData.stampOut).getHours(),
              minute: Utility.ConvertUTCDateToLocalDate(resData.stampOut).getMinutes(),
              second: 0,
            });
          }
          this.userClockInForm.controls.userId.disable();
          this.spinner.hide();
        }
        this.userClockInForm.markAsPristine();
        this.spinner.hide();
      })
      .catch((err) => {
        this.spinner.hide();
      });
  }

  private async getUsers() {
    this.spinner.show();
    await this.userClockInOutService
      .getUsers()
      .then((response) => {
        this.userList = this.mapUser(response);
        this.spinner.hide();
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  private mapUser(array: any[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach((element) => {
        let single = Object();
        single.value = element.userId;
        single.text = element.name;

        supperArray.push(single);
      });
    }
    return supperArray;
  }

  private bindForm() {
    this.userClockInForm = new FormGroup({
      id: new FormControl(),
      userId: new FormControl(),
      stampInDate: new FormControl(),
      stampInTime: new FormControl(),
      stampOutDate: new FormControl(),
      stampOutTime: new FormControl(),
      comment: new FormControl(),
    });
  }

  private setUserStampInOut(registerUserStamp: any) {
    this.spinner.show();
    this.dataProvider
      .Post<any>(Urls.RegisterUserStamp, registerUserStamp)
      .toPromise()
      .then(async (response) => {
        this.spinner.hide();
        if (response.responseCode === Constant.SuccessResponseCode && response.responseObject) {
          this.toastr.success(this.translate.instant(this.userClockInOutService.isEdit ? "lblUserStampEditSuccess" : "lblUserStampAddSuccess"));
          this.activeModal.close({ success: true });
        } else {
          this.toastr.error(this.translate.instant(this.userClockInOutService.isEdit ? "lblUserStampEditFail" : "lblUserStampAddFail"));
        }
      })
      .catch((err) => {
        this.spinner.hide();
      });
  }

  private getDate(dateString: string): Date {
    const [day, month, year] = dateString.split('.').map(Number);
    return new Date(year, month - 1, day);
  }
}
